import React from "react";

/** Utility to generate URL-safe slugs for headings */
export function slugifyText(node: React.ReactNode): string {
  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(slugifyText).join(" ");
  }
  if (
    React.isValidElement(node) &&
    (node.props as { children?: React.ReactNode })?.children
  ) {
    return slugifyText((node.props as { children?: React.ReactNode }).children);
  }
  return "";
}

export function slugify(text: React.ReactNode): string {
  const plainText = slugifyText(text);
  return plainText
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-äöüß]/g, "")
    .replace(/\s+/g, "-")
    .replace(/--+/g, "-");
}
